module.exports = __webpack_public_path__ + "img/xhl-logo.d3ed5549.png";